// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.is-plain[data-v-12353495]{--el-button-active-text-color:var(--el-color-primary);--el-button-active-border-color:var(--el-color-primary)}.el-button--primary.is-plain[data-v-12353495]{--el-button-border-color:var(--el-color-primary-light-3)}.el-link.el-link--primary[data-v-12353495]:hover{color:var(--el-color-primary-light-3)}.chapter-input[data-v-12353495] .el-input__inner{cursor:pointer}.chapter-input[data-v-12353495] .el-icon{height:inherit;cursor:pointer}", ""]);
// Exports
module.exports = exports;
